export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-[580px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-medium bg-primary-100/80 text-primary-700 rounded-full mb-5">
              韩漫 · 日漫 · 国漫
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              亲亲漫画
              <span className="block text-primary-600 mt-1">海量免费漫画在线阅读平台</span>
            </h1>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              精选韩漫、日漫、国漫热门作品，免费全集下拉式阅读体验。无论你偏爱浪漫爱情、热血战斗、奇幻冒险还是悬疑推理，亲亲漫画每日更新推荐，让好看的漫画触手可及。每期精选专题帮你发现下一个心头好，下拉即读，畅快追漫。
            </p>

            <div className="mt-7 flex flex-wrap items-center justify-center lg:justify-start gap-6">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-book-open-line text-accent-600 text-sm"></i>
                </div>
                <div className="text-left">
                  <p className="text-lg font-semibold text-foreground-900">50,000+</p>
                  <p className="text-xs text-foreground-500">部漫画资源</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-user-heart-line text-accent-600 text-sm"></i>
                </div>
                <div className="text-left">
                  <p className="text-lg font-semibold text-foreground-900">800万+</p>
                  <p className="text-xs text-foreground-500">活跃读者</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-timer-flash-line text-accent-600 text-sm"></i>
                </div>
                <div className="text-left">
                  <p className="text-lg font-semibold text-foreground-900">每日更新</p>
                  <p className="text-xs text-foreground-500">不间断连载</p>
                </div>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                热门推荐
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-800 font-medium text-sm rounded-full border border-background-300/60 hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-trophy-line"></i>
                人气榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-secondary-100/50">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20warm%20digital%20manga%20reading%20scene%20with%20tablet%20displaying%20colorful%20comic%20panels%2C%20person%20relaxing%20on%20sofa%2C%20floating%20manga%20panels%20with%20Korean%20Japanese%20Chinese%20comic%20art%20style%2C%20warm%20coral%20and%20amber%20lighting%2C%20modern%20interior%20with%20bookshelf%2C%20artistic%20illustration%2C%20soft%20atmosphere%2C%20editorial%20quality%2C%20clean%20composition%2C%20immersive%20reading%20vibe&width=800&height=600&seq=qinqin-hero-01&orientation=landscape"
                alt="亲亲漫画在线阅读体验 - 韩漫日漫国漫免费下拉式阅读"
                title="亲亲漫画 韩漫日漫国漫热门推荐 免费全集在线阅读"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) {
                    target.parentElement.style.display = 'none';
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}